import React from "react";
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";

const ForbiddenSection = ({ routeData }) => {
  return (
    <div className="forbidden-container">
      <div className="question-container">
        <img alt="" src={require("@/assets/images/404-question.svg")} />
        <div className="title">お探しのページはご利用できません</div>
        <div className="description">
          いつもTrynibusをご利用いただきありがとうございます。
          <br />
          あなたがアクセスしようとしたページは表示することが出来ませんでした。
          <br />
          アクセスが許可されていない場合があります。
        </div>
      </div>
      <Placeholder
        name="jss-contact"
        rendering={routeData}
        routeData={routeData}
      />
    </div>
  );
};

export default ForbiddenSection;
